import { Component, Inject, OnInit } from '@angular/core';

import { api, userPermissions } from '@src/constants';

import { userActions } from '@src/store/reducers/userReducer';
import { licenseActions } from '@src/store/reducers/licenseReducer';
import { Store } from '@src/store';

@Component({
    selector: 'about',
    template: require('./about.component.html'),
    styles: [require('./about.component.scss')]
})
export class AboutComponent implements OnInit {
    public version: string = api.version;
    public license: any;
    public isGlobalAdmin: boolean;
    public totalProjects: any;
    public totalConnections: any;
    public totalProjectGroups: any;
    public totalUsers: any;
    public totalActiveUsers: any;
    public totalDisavtiveUser: any;
    public totalEnvironments: any;
    public totalLicenseEnvironments: any;
    public totalLicenseConnections: any;
    public environments: any;
    public connectionCounts: any = [];

    constructor(
        private store: Store,
        @Inject('authorizationService') private authorizationService: any) {
        this.authorizationService = authorizationService;
    }

    public async ngOnInit() {
        this.license = await this.store.dispatch({ type: licenseActions.GET_CURRENT_LICENSE });
        this.isGlobalAdmin = await this.authorizationService.isAuthorizedToPerformAction(userPermissions.GrantAndRevokePrivileges);
        if (this.isGlobalAdmin) {
            const res: any = await this.store.dispatch({ type: userActions.GET_USAGE_INFO });
            if (res.data) {
                this.totalProjects = res.data.totalProjects;
                this.totalProjectGroups = res.data.totalProjectGroups;
                this.totalUsers = res.data.totalUsers;
                this.totalActiveUsers = res.data.totalActiveUsers;
                this.totalDisavtiveUser = res.data.totalDisavtiveUser;
                this.totalEnvironments = res.data.totalEnvironments;
                this.totalLicenseEnvironments = res.data.totalLicenseEnvironments;
                this.totalLicenseConnections = res.data.totalLicenseConnections;
                this.totalConnections = res.data.totalConnections;
                this.connectionCounts = res.data.connectionCounts;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/about/about.component.ts